import {useFormatNumber} from 'platform/locale';

import {useMemo} from 'react';

import {useCatalogue} from '../../../hooks/useCatalogue';
import {PriceReportType} from '../../../types/PriceReportType';
import {FilterSummaryHelpers} from '../utils/buildFilterSummary';
import {useFormatPanelPrice} from './useFormatPanelPrice';

/** Catalogue label getters + formatters for {@link buildFilterSummary}. */
export function useFilterSummaryHelpers(priceReport: PriceReportType): FilterSummaryHelpers {
  const {getCarStyle, getFuelType, getDrive, getTransmission} = useCatalogue();
  const formatNumber = useFormatNumber();
  const formatPrice = useFormatPanelPrice(priceReport);

  return useMemo(
    () => ({
      getCarStyle,
      getFuelType,
      getDrive,
      getTransmission,
      formatNumber: (value) => formatNumber(value) ?? String(value),
      formatPrice,
    }),
    [getCarStyle, getFuelType, getDrive, getTransmission, formatNumber, formatPrice]
  );
}
